import { defaultThemeVariables } from './default-theme-variables';
import { color } from './variable-constants';

export const altThemeVariables = {
  ...defaultThemeVariables,
  '--action-primary': color.amber,
  '--action-primary-shadow': color.green,
  '--action-secondary': color.vmBlue,
  '--action-secondary-shadow': color.lime,
  '--action-tertiary': color.magenta,
  '--action-tertiary-shadow': color.vmRed
};
